import { Navigate, Outlet } from "react-router-dom";
import { useGetUserRole } from "../hooks/useGetUserRole";
import { Spinner } from "../components/Spinner";

const PrivateRoutes = ({ allowedRoles }) => {
  const authToken = sessionStorage.getItem("authToken");
  const { role, isLoading } = useGetUserRole();

  if (isLoading) {
    return (
      <div className="h-[100vh] w-full flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!authToken) {
    return <Navigate to={"/"} />;
  }

  // If user’s role is not allowed → send to dashboard
  if (allowedRoles && !allowedRoles?.includes(role)) {
    return <Navigate to="/dashboard" />;
  }

  return <Outlet />;
};
export default PrivateRoutes;
